import {apiRequest} from './client';
import type {RevealedSiteCredential, SiteCredentials, SiteId} from '@/types/api';

export function getSiteCredentials(siteId: SiteId): Promise<SiteCredentials> {
    return apiRequest<SiteCredentials>(`/sites/${siteId}/credentials`, {method: 'GET'});
}

export function revealSiteAdminKey(siteId: SiteId): Promise<RevealedSiteCredential> {
    return apiRequest<RevealedSiteCredential>(`/sites/${siteId}/credentials/admin/reveal`, {method: 'POST'});
}

export function rotateSiteAdminKey(siteId: SiteId): Promise<RevealedSiteCredential> {
    return apiRequest<RevealedSiteCredential>(`/sites/${siteId}/credentials/admin/rotate`, {method: 'POST'});
}

export function revokeSiteAdminKey(siteId: SiteId): Promise<{success: true}> {
    return apiRequest<{success: true}>(`/sites/${siteId}/credentials/admin/revoke`, {method: 'POST'});
}

export function createSiteAdminKey(siteId: SiteId): Promise<RevealedSiteCredential> {
    return apiRequest<RevealedSiteCredential>(`/sites/${siteId}/credentials/admin/create`, {method: 'POST'});
}
